import { useEffect } from "react";

/** Injects a JSON-LD structured-data script into <head> for rich results. */
export default function JsonLd({ id, data }) {
  useEffect(() => {
    document.getElementById(id)?.remove();
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.id = id;
    s.text = JSON.stringify(data);
    document.head.appendChild(s);
    return () => document.getElementById(id)?.remove();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, JSON.stringify(data)]);
  return null;
}
